<template>
  <b-card title="Temas Tipleri">
    <b-row v-show="meets.chart.series.length > 0">
      <b-col>
        <apex-donut-chart
          :categories-data="meets.chart.categories"
          :series-data="meets.chart.series"
        />
      </b-col>
      <b-col class="d-flex align-items-center">
        <b-list-group class="w-100">
          <b-list-group-item
            v-for="item in meets.data"
            :key="item.id"
          >
            <div class="d-flex justify-content-between">
              <div class="font-weight-bold text-primary">
                {{ item.title }}
              </div>
              <div class="font-weight-bold">
                {{ item.count }} Adet
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <empty-alert v-if="meets.chart.series.length === 0" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import ApexDonutChart from '@/views/Admin/Reports/charts/ApexDonutChart.vue'
import EmptyAlert from '@/views/Admin/Reports/common/EmptyAlert.vue'

export default {
  name: 'Meets',
  components: {
    BCard,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    ApexDonutChart,
    EmptyAlert,
  },
  computed: {
    meets() {
      return this.$store.getters['interviewReports/meets']
    },
  },
}
</script>
